module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MakeSameSize_16"],"path":[{"$":{"d":"M5.38,6.86,4,8.24V4H8.24L6.79,5.45l3.83,3.69L12,7.76V12H7.76l1.45-1.45ZM10,0H0V10H2V2h8Zm4,6v8H6v2H16V6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MakeSameSize_16.svg
// module id = VSl2
// module chunks = 1